import containerConnect from '@configuratorware/configurator-frontendgui/Framework/ComponentContainer';
import { Services } from '@configuratorware/configurator-frontendgui/App/ServiceLocator';
import {
  areAllDesignAreasEmpty,
  getSelectedDesignAreaProperties,
  getDesignDataForFilteredDesignAreas,
  getColors,
  isColoringDisabled,
} from '@configuratorware/configurator-frontendgui/App/Reducers/DesignArea/Selectors';
import DesignPicker from '../Components/DesignPicker';
import { setDesignerOptionRef } from '../../../Reducers/CustomDesignReducer/Actions';

const mapStateToProps = (state) => {
  const {
    filteredDesignAreas,
    maxColorAmount: maxColorAmountSource,
    designProductionMethod,
    selectedDesignArea,
  } = getSelectedDesignAreaProperties(state);
  return {
    Component: DesignPicker,
    showCallToAction: areAllDesignAreasEmpty(state.configurator),
    designAreas: filteredDesignAreas || [],
    openDesignArea: () => Services.designData.openDesignAreaEditor(),
    selectedDesignArea,
    handleChangeDesignArea: (value) => Services.designData.selectDesignArea(value),
  };
};

const mapDispatchToProps = (dispatch) => ({
  addOptionsRef: (identifier, value) => dispatch(setDesignerOptionRef(identifier, value)),
});

export default containerConnect(mapStateToProps, mapDispatchToProps);
